import dotenv from "dotenv";

dotenv.config();

//
// General config
// ------------------------------------------------------------------

export const APP_NAME = process.env.APP_NAME;
export const REACT_APP_ENV_TYPE = process.env.REACT_APP_ENV_TYPE;


// 
//  Site 
// ------------------------------------------------------------------
export const APP_SITE = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://lamainteractives.com';
export const APP_API = process.env.NODE_ENV === 'development' ? 'http://localhost:10008/wp-json/' : 'https://lamainteractives.com/cms/wp-json/';


export const BASE_S3_BUCKET = "https://lamainteractives.s3.us-west-2.amazonaws.com";


// 
//  Contact form id 
// ------------------------------------------------------------------
export const CONTACT_FORM_ID = 170;


export const NEWSLETTER_FORM_ID = 169;


//
// Development environment config
// ------------------------------------------------------------------

export const DEBUG = process.env.DEBUG === "true";

//
// Server config
// ------------------------------------------------------------------

export const PORT = process.env.PORT;

//
// Datanase config
// ------------------------------------------------------------------

export const DATABASE_URL = process.env.DATABASE_URL;



///
// Test users (these external emails are allow to access hub)
// ------------------------------------------------------------------

export const TEST_USERS = process.env.REACT_APP_TEST_USERS;


//
// Google auth config
// ------------------------------------------------------------------

export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
export const GOOGLE_CLIENT_SECRET = process.env.GOOGLE_CLIENT_SECRET;
export const GOOGLE_CLIENT_EMAIL = process.env.GOOGLE_CLIENT_EMAIL;
export const GOOGLE_CLIENT_EMAIL_PASSWORD = process.env.GOOGLE_CLIENT_EMAIL_PASSWORD;
export const GOOGLE_AUTH_CALLBACK_URL = process.env.GOOGLE_AUTH_CALLBACK_URL;
export const GOOGLE_AUTH_SUCCESS_REDIRECT = "/hub";
export const GOOGLE_AUTH_FAILURE_REDIRECT = "/login-failure";
export const SESSION_COOKIE_SECRET = "richard-lama-portfolio-cookie";

//
// Development env in server
// ------------------------------------------------------------------
export const DEVELOPMENT_ENVIRONMENT = process.env.DEVELOPMENT_ENVIRONMENT === "true" ? true : false;

//
// Local dummy auth config
// ------------------------------------------------------------------

export const LOCAL_DEV_ENVIRONMENT =
  process.env.LOCAL_DEV_ENVIRONMENT !== undefined
    ? process.env.LOCAL_DEV_ENVIRONMENT === "true"
    : undefined;
export const LOCAL_DUMMY_AUTH_NAME = process.env.LOCAL_DUMMY_AUTH_NAME;
export const LOCAL_DUMMY_AUTH_EMAIL = process.env.LOCAL_DUMMY_AUTH_EMAIL;
export const LOCAL_DUMMY_AUTH_ID = process.env.LOCAL_DUMMY_AUTH_ID;
export const LOCAL_DUMMY_AUTH_IMAGE = process.env.LOCAL_DUMMY_AUTH_IMAGE;
export const LOCAL_DUMMY_AUTH_ACCESS_TOKEN =
  process.env.LOCAL_DUMMY_AUTH_ACCESS_TOKEN;
export const LOCAL_DUMMY_AUTH_GROUP = process.env.LOCAL_DUMMY_AUTH_GROUP;

//
// Local front-end development environment variables
// ------------------------------------------------------------------

// These two config variables are included to make your life easier, when you're developing locally.
// To do a "fully-fledged" test with server and front-end aspects of the application running, you
// need to run both `yarn dev:client` and `yarn dev:server`.
//
// However, this is kind of a pain, as every change you make to the code requires a full rebuild
// of the application to be rendered, breaking CRA's development server and destroying productivity.
//
// What these config variables allow you to do is bypass the login screen - it ensures you're logged
// in as the user below - and so do the vast majority of your development work using the standard
// `yarn start` create-react-app development server, with all it's hot-module-reloading goodness.

export const LOCAL_FE_DEV_ENVIRONMENT =
  LOCAL_DEV_ENVIRONMENT !== undefined ||
    LOCAL_DEV_ENVIRONMENT === false ||
    (typeof window !== "undefined" &&
      window.origin.indexOf("localhost:4000") === -1)
    ? false
    : true;

export const LOCAL_FE_DEV_USER = LOCAL_FE_DEV_ENVIRONMENT
  ? {
    email: process.env.REACT_APP_LOCAL_DEV_EMAIL
      ? process.env.REACT_APP_LOCAL_DEV_EMAIL
      : "sorenfrederiksen@fairfaxmedia.com.au",
    id: "1",
    image: process.env.REACT_APP_LOCAL_DEV_IMAGE
      ? process.env.REACT_APP_LOCAL_DEV_IMAGE
      : "https://lh5.googleusercontent.com/-TVlUfW4EG28/AAAAAAAAAAI/AAAAAAAAAIw/cFml0Yhy_-A/photo.jpg",
    group: process.env.REACT_APP_LOCAL_DEV_GROUP
      ? process.env.REACT_APP_LOCAL_DEV_GROUP
      : "admin_user",
    name: process.env.REACT_APP_LOCAL_DEV_NAME
      ? process.env.REACT_APP_LOCAL_DEV_NAME
      : "Soren Frederiksen",
    token: "aaa"
  }
  : undefined;

//
// AWS config
// ------------------------------------------------------------------

export const AWS_BUCKET_URL_ROOT = process.env.AWS_BUCKET_URL_ROOT;
export const AWS_ACCESS_ID = process.env.AWS_ACCESS_ID;
export const AWS_BUCKET_NAME = process.env.AWS_BUCKET_NAME;
export const AWS_SECRET_KEY = process.env.AWS_SECRET_KEY;
export const AWS_MAX_FILE_UPLOAD_SIZE_IN_MB =
  process.env.AWS_MAX_FILE_UPLOAD_SIZE_IN_MB === undefined
    ? 5
    : +process.env.AWS_MAX_FILE_UPLOAD_SIZE_IN_MB;

//
// AWS interactives config  
// ------------------------------------------------------------------

export const AWS_INTERACTIVES_ACCESS_ID = process.env.AWS_INTERACTIVES_ACCESS_ID;
export const AWS_INTERACTIVES_BUCKET_NAME = process.env.AWS_INTERACTIVES_BUCKET_NAME;
export const AWS_INTERACTIVES_SECRET_KEY = process.env.AWS_INTERACTIVES_SECRET_KEY;


/// Sample skills list json.  It is stored in worpdress users form field "site list"
export const SKILLS_LIST = [
  {
    "type": "JavaScript libraries & frameworks",
    "icon": "",
    "desc": "",
    "value": 0,
    "order": -1,
    "name": ""
  },
  {
   "type": "vis",
    "icon": "d3-3.png",
    "desc": "D3 has always been a part of my client side  applications. Most of my chart and map applications are built with D3.",
    "value": 90,
    "order": 1,
    "name": "D3"
  },
  {
   "type": "vis",
    "icon": "react-3.png",
    "desc": "Currently I head start my applications with Reactjs in a daily basis.",
    "value": 99,
    "order": 0,
    "name": "Reactjs"
  },
  {
   "type": "vis",
    "icon": "angular-3.png",
    "desc": "I have used it for all the client side applications before the current job. I might need a week or so to head start again if I have to.",
    "value": 70,
    "order": 3,
    "name": "Angular"
  },
  {
   "type": "vis",
    "icon": "javascript-3.png",
    "desc": "For me Vanilla javascript is the quickest way to turn around prototypes, and have been using it since its birth.",
    "value": 99,
    "order": 4,
    "name": "Javascript"
  },
  {
   "type": "vis",
    "icon": "tensorflow-3.png",
    "desc": "TensorFlow is a free and open-source software library for machine learning and artificial intelligence by Google. I have been using it for a while now, mostly on prototypes. In fact I have used this library with the available Toxicity model  to detect the toxic content such as threatening language, insults, obscenities, identity-based hate, or sexually explicit language in the contact form below. The form also has spam detection feature. This is using my customized model which I retrained with additional spam data.",
    "value": 65,
    "order": 3,
    "name": "Tensorflow Js"
  },
  {
   "type": "vis",
    "icon": "leaflet-3.png",
    "desc": "Leaflet is an open source JavaScript library used to build web mapping applications. I have used this quite a lot in my applications.",
    "value": 95,
    "order": 3,
    "name": "Leaflet Maps"
  },
  {
   "type": "vis",
    "icon": "googlemaps-3.png",
    "desc": "I have a hand full of experience using and implementing Google Maps and its services like street maps, 360° interactive panoramic views of streets, real-time traffic conditions, route planning for traveling and etc. Also have used this along with geojson and topojson map data which are basically a type of geospatial data interchange format.",
    "value": 90,
    "order": 3,
    "name": "Google Maps Api"
  },
  {
   "type": "vis",
    "icon": "threejs-3.png",
    "desc": "Threejs is my preferred library to handle 3D elements in the web.",
    "value": 85,
    "order": 3,
    "name": "ThreeJs 3D library"
  },
  {
   "type": "vis",
    "icon": "typescript-3.png",
    "desc": "I would prefer both Typescript or Vanilla Javascript depending on the project.",
    "value": 90,
    "order": 5,
    "name": "Typscript"
  },
  {
   "type": "vis",
    "icon": "greensock-3.png",
    "desc": "This is an industry standard JavaScript animation library from GreenSock that lets us craft high-performance animations for every major browser. I use this library in a regular basis.",
    "value": 90,
    "order": 3,
    "name": "GreenShock Library"
  },
  {
   "type": "vis",
    "icon": "lottie-3.png",
    "desc": "Lottie is an iOS, Android, and React Native library that renders After Effects animations in real time, allowing apps to use animations as easily as they use static images. I often use this library to enhance my applications.",
    "value": 90,
    "order": 3,
    "name": "Lottie animations"
  },
  {
   "type": "vis",
    "icon": "phaser.png",
    "desc": "I have create a couple of html5 games using Phaser.io. It is a free open sourced, fast games building canvas and webGl based framework. I found this software quite intuitive, easy to head start and fast to develop games and any type of interactive applications.",
    "value": 75,
    "order": 3,
    "name": "Phaser"
  },
  {
    "type": "Backend Technologies",
    "icon": "",
    "desc": "",
    "value": 0,
    "order": -1,
    "name": ""
  },
  {
   "type": "vis",
    "icon": "nodejs-3.png",
    "desc": "Node has been an essential part of every developer. I have been using it to its limit in server side and local environments in most of my applications.",
    "value": 100,
    "order": 2,
    "name": "Nodejs"
  },
  {
   "type": "vis",
    "icon": "php-3.png",
    "desc": "I have a long history using php with MySQL. Slim v4 is my preferred php framework for the REST api. I have setup and implemented php REST api on Heroku using Slim framework. This api provides several end points processing Postgres and MySQL database, external api and google sheet data ",
    "value": 90,
    "order": 3,
    "name": "Php"
  },
  {
   "type": "vis",
    "icon": "python.png",
    "desc": "I have hands on experience with Python programming language. Though it is limited to basic level task. Lately I have been using it on google code lab to learn Tensorflow for Machine Learning.",
    "value": 45,
    "order": 3,
    "name": "Python"
  },
  {
   "type": "vis",
    "icon": "wordpress-3.png",
    "desc": "I am very comfortable using Wordpress as cms as well as creating and using it as a REST api to serve data to client side applications. This site is build with React in the client side using data from the Wordpress rest api.  I implemented this technique to speed up this site which is hosted in reasonably slow and cheap server.",
    "value": 85,
    "order": 3,
    "name": "Wordpress"
  },
  {
   "type": "vis",
   "type": "vis",
    "icon": "mysql-3.png",
    "desc": "MySQL along with PostgreSQL are my preferred database management systems. ",
    "value": 90,
    "order": 3,
    "name": "MySql Database"
  },
  {
   "type": "vis",
    "icon": "postgres-3.png",
    "desc": "PostgreSQL along with MySQL are my preferred database management systems.",
    "value": 80,
    "order": 3,
    "name": "Postgres Database"
  },
  {
   "type": "vis",
    "icon": "googleappscript-3.png",
    "desc": "Google Apps Script is a scripting platform developed by Google for light-weight application development in the Google Workspace platform. I have used this extensively to process spreadsheets.",
    "value": 90,
    "order": 3,
    "name": "Google Appscript"
  },
  {
   "type": "vis",
    "icon": "slim.png",
    "desc": "Slim is a PHP micro framework that helps you quickly write simple yet powerful web applications and APIs.",
    "value": 90,
    "order": 3,
    "name": "Slim 4 php framework"
  },
  {
    "type": "Multimedia technologies",
    "icon": "",
    "desc": "",
    "value": 0,
    "order": -1,
    "name": ""
  },
  {
   "type": "vis",
    "icon": "aftereffects-3.png",
    "desc": "I am proficient using Adobe After Effects, which is a digital visual effects, motion graphics, and compositing sotware. I have also coded and created dynamic videos with ExtendScript which provides a common scripting environment for all Adobe JavaScript-enabled applications.",
    "value": 90,
    "order": 3,
    "name": "Adobe After Effects"
  },
  {
   "type": "vis",
    "icon": "premiere-3.png",
    "desc": "Adobe Premiere is a timeline-based and non-linear video editing software, I have been using it for years.",
    "value": 90,
    "order": 3,
    "name": "Adobe Premeire"
  },
  {
   "type": "vis",
    "icon": "maya-3.png",
    "desc": "Autodesk Maya is my preferred software for creating 3D elements. It provides 3D animation, modelling, simulation, and rendering all in one toolset. ",
    "value": 70,
    "order": 3,
    "name": "Autodesk Maya"
  },
  {
   "type": "vis",
    "icon": "ffmpeg.png",
    "desc": "Extensive use of FFMPEG lib for processing of video and audio files",
    "value": 90,
    "order": 3,
    "name": "FFMPEG"
  },
  {
   "type": "vis",
    "icon": "qgis-3.png",
    "desc": "I use Qgis software to pre process, clean up and optimise raw spatial map data. This software allows to create, edit, visualise, analyse and publish geospatial information.",
    "value": 55,
    "order": 3,
    "name": "Qgis mapping software"
  },
  {
    "type": "Cloud Services",
    "icon": "",
    "desc": "",
    "value": 0,
    "order": -1,
    "name": ""
  },
  {
   "type": "vis",
    "icon": "google-cloud.png",
    "desc": "Often had to deal with google cloud products and apis, such as  Drive, Sheet, Maps, Places, Street, Dialogueflow and etc.",
    "value": 70,
    "order": 3,
    "name": "Google Cloud Services"
  },
  {
   "type": "vis",
    "icon": "aws.png",
    "desc": "Hands on experience with Amazon services platforms and APIs. ",
    "value": 90,
    "order": 3,
    "name": "AWS Web Services"
  },
  {
   "type": "vis",
    "icon": "zapier.png",
    "desc": "Have used Zapier products that allows end users to integrate the web applications to automate workflows. ",
    "value": 70,
    "order": 3,
    "name": "Zapier Services",
    "link": "https://zapier.com/"
  },
  {
    "type":"Other",
    "icon": "",
    "desc": "",
    "value": 0,
    "order": -1,
    "name": ""
  },
  {
   "type": "vis",
    "icon": "sass-3.png",
    "desc": "I have used Sass as the primary css preprocessor in my applications.",
    "value": 99,
    "order": 3,
    "name": "Sass css preproccesor"
  },
  {
   "type": "vis",
    "icon": "github-3.png",
    "desc": "Proficient working with git library on both Github and Bitbucket platforms.",
    "value": 99,
    "order": 3,
    "name": "Github"
  }
]


export default {
  APP_NAME,
  AWS_ACCESS_ID,
  AWS_BUCKET_NAME,
  AWS_BUCKET_URL_ROOT,
  AWS_MAX_FILE_UPLOAD_SIZE_IN_MB,
  AWS_SECRET_KEY,
  AWS_INTERACTIVES_ACCESS_ID,
  AWS_INTERACTIVES_BUCKET_NAME,
  AWS_INTERACTIVES_SECRET_KEY,
  DATABASE_URL,
  DEBUG,
  GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET,
  GOOGLE_AUTH_CALLBACK_URL,
  GOOGLE_AUTH_SUCCESS_REDIRECT,
  GOOGLE_AUTH_FAILURE_REDIRECT,
  LOCAL_DEV_ENVIRONMENT,
  LOCAL_DUMMY_AUTH_NAME,
  LOCAL_DUMMY_AUTH_EMAIL,
  LOCAL_DUMMY_AUTH_ID,
  LOCAL_DUMMY_AUTH_IMAGE,
  LOCAL_DUMMY_AUTH_ACCESS_TOKEN,
  LOCAL_DUMMY_AUTH_GROUP,
  LOCAL_FE_DEV_ENVIRONMENT,
  LOCAL_FE_DEV_USER,
  PORT,
  SESSION_COOKIE_SECRET,
  REACT_APP_ENV_TYPE,
  TEST_USERS,
  SKILLS_LIST
};
